import { postTencentCaptchaApi } from '@/api/common'
import { SUCCESS_CODE, TENCENT_APPID } from '@/utils/constants'
import { FormInstance, Message } from '@arco-design/web-react'
import useLocale from '@/utils/useLocale'
import useLang from '@/utils/useLang'
import { emailReg } from '@/utils/index'
declare const TencentCaptcha: any

export interface ICaptchaResult {
  ret: number
  ticket: string
  randstr: string
  CaptchaAppId?: string
  bizState?: string
  errorCode?: number
  errorMessage?: string
}

export const useEmailCaptcha = (form: FormInstance, onSuccess: () => void) => {
  const t = useLocale()
  const lang = useLang()
  const isChinese = lang === 'zh-CN'

  const handleCaptchaCallback = async (res: ICaptchaResult) => {
    if (res.ret === 0) {
      const { email } = form.getFields()
      const resData = await postTencentCaptchaApi({
        ticket: res.ticket,
        rand_str: res.randstr,
        email
      })
      resData?.data?.code === SUCCESS_CODE && onSuccess()
    }
  }

  const handleLoadError = () => {
    const appid = TENCENT_APPID
    // 生成容灾票据或自行做其它处理
    const ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000)
    handleCaptchaCallback({
      ret: 0,
      randstr: '@' + Math.random().toString(36).substr(2),
      ticket: ticket,
      errorCode: 1001,
      errorMessage: 'jsload_error'
    })
  }

  async function onCaptchaShow() {
    try {
      const { email } = form.getFields()
      if (!email || !emailReg.test(email)) {
        return Message.error(t['login.form.email.errMsg'])
      }
      // 生成一个验证码对象
      // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
      // callback：定义的回调函数
      const captcha = new TencentCaptcha(TENCENT_APPID, handleCaptchaCallback, {
        userLanguage: isChinese ? 'zh-cn' : 'en'
      })
      // 调用方法，显示验证码
      captcha.show()
    } catch (error) {
      console.log('loadErrorCallback回调函数:', error)
      // 加载异常，调用验证码js加载错误处理函数
      handleLoadError()
    }
  }

  return { handleCaptchaCallback, handleLoadError, onCaptchaShow }
}
